import Image from "next/image";

import AnchorLink from "@/components/ui/AnchorLink/AnchorLink";
import { appDownloadTracking } from "@/dataLayer/dataLayer";

export type DeviceStoreProps = {
  img: string;
  url: string;
  alt: string;
};

export default function DeviceStore({ img, url, alt }: DeviceStoreProps) {
  return (
    <AnchorLink href={url} onClick={(e) => appDownloadTracking(alt)}>
      <Image src={img} width="125" height="43" alt={alt} />
    </AnchorLink>
  );
}
